import {VehicleFinancingTemplateResponseBody} from '@dms/api/sales';
import {Money} from '@dms/api/shared';

import {CurrencyCodeType, currencyCodes, Nullish} from 'shared/web';

export interface TemplateMoneyCurrencies {
  processingFee: CurrencyCodeType;
  vehicleTransferAmount: CurrencyCodeType;
  vehicleRegistrationAmount: CurrencyCodeType;
  vehicleDeliveryAmount: CurrencyCodeType;
  sellingPriceFrom: CurrencyCodeType;
  sellingPriceTo: CurrencyCodeType;
}

const toCurrencyCode = (money: Money | Nullish, fallback: CurrencyCodeType): CurrencyCodeType =>
  currencyCodes.find((code) => code === money?.currency) ?? fallback;

/**
 * Fields with no stored `Money` (create mode, or an amount the user is entering for the first
 * time) resolve to `tenantCurrency` — the currency their input is labelled with.
 */
export function resolveTemplateMoneyCurrencies(
  template: VehicleFinancingTemplateResponseBody | Nullish,
  tenantCurrency: CurrencyCodeType
): TemplateMoneyCurrencies {
  return {
    processingFee: toCurrencyCode(template?.processingFee, tenantCurrency),
    vehicleTransferAmount: toCurrencyCode(template?.vehicleTransferAmount, tenantCurrency),
    vehicleRegistrationAmount: toCurrencyCode(template?.vehicleRegistrationAmount, tenantCurrency),
    vehicleDeliveryAmount: toCurrencyCode(template?.vehicleDeliveryAmount, tenantCurrency),
    sellingPriceFrom: toCurrencyCode(template?.scope.segment.sellingPriceFrom, tenantCurrency),
    sellingPriceTo: toCurrencyCode(template?.scope.segment.sellingPriceTo, tenantCurrency),
  };
}
